import { isRooftopLite } from '@utils/tiers';

/** Whether the Drivers pages render for this rooftop: a Lite rooftop (`customers.tier`). The Valet
 * header's Manage Drivers link reads the same gate, so the link never opens a blank page. */
export function isDriversPageAvailable(rooftop: { tier?: string | null } | null | undefined): boolean {
  return isRooftopLite(rooftop);
}
